document.addEventListener("DOMContentLoaded", (event) => {
  document.querySelectorAll('.stl-btn,.stl-link').forEach(function(shopLookBtn){
    shopLookBtn.addEventListener('click',function(e){
      e.preventDefault();
      let currentVal = shopLookBtn.getAttribute('data-val');
      let shop_look = shopLookBtn.closest('.main-shop-look').querySelector('.snippet-shop-the-look-drawer');
      if(shop_look){
        shop_look.remove();
        document.body.appendChild(shop_look);
      }
      document.querySelectorAll('.shop-look-count span').forEach((shopLookCount) => {
        let count = shopLookCount.getAttribute('data-val');
        if(count == currentVal){
          document.querySelectorAll('.shop-look-count span').forEach((shopCountRemove) => {
            shopCountRemove.classList.remove('active-count');
          });
          shopLookCount.classList.add('active-count');
        }
      })
      document.querySelectorAll('.shop-look-items').forEach((shopLookItem) => {
        let item = shopLookItem.getAttribute('data-val');
        if(item == currentVal){
          document.querySelectorAll('.shop-look-items').forEach((shopItemRemove) => {
            shopItemRemove.classList.remove('active-item');
          });
          shopLookItem.classList.add('active-item');
        }
      })
      if(__st.p == 'home' && window.innerWidth <= 991){
        if (intentObserver && preventScroll) {
          intentObserver.disable();
          preventScroll.disable();
        }
      }
      setTimeout(() => {
        document.querySelector('body').classList.add('open-shop-look');
        document.querySelector('body').classList.remove('open-drawer','open-menu','open-search','open-sort','open-filter','open-quick-buy');
      }, 100);
    });
  });
  if(document.querySelectorAll('.shop-look-close')) document.querySelectorAll('.shop-look-close').forEach((stl_drawer_close) => {
    stl_drawer_close.addEventListener('click',function(e){
      if(__st.p == 'home' && window.innerWidth <= 991){
        if (intentObserver && preventScroll) {
          intentObserver.enable();
          preventScroll.enable();
        }
      }
      document.querySelector('body').classList.remove('open-shop-look');
    });
  });
});
if(document.querySelectorAll('.snippet-shop-the-look-drawer')) document.querySelectorAll('.snippet-shop-the-look-drawer').forEach((stl_drawer) => {
  stl_drawer.addEventListener('scroll',(e) => {
    let searchTop = stl_drawer.scrollTop;
    let getTop = stl_drawer.querySelector('.shop-look-product').offsetTop;
    if(searchTop > getTop){
      stl_drawer.classList.add('active-stl-head');
    }else{
      stl_drawer.classList.remove('active-stl-head');
    }
  });
});
if(document.querySelectorAll('.stl-media-wrap,.stlh-left-media,.looks-caro-slide')) document.querySelectorAll('.stl-media-wrap,.stlh-left-media,.looks-caro-slide').forEach(function(stl_media){
  stl_media.addEventListener('mouseover', function(){
    stl_media.querySelector('.stl-product-count').style.width = stl_media.querySelector('.stl-product-count span').offsetWidth+'px';
    stl_media.classList.add('active');
  });
  stl_media.addEventListener('mousemove', function(){
    stl_media.querySelector('.stl-product-count').style.width = stl_media.querySelector('.stl-product-count span').offsetWidth+'px';
    stl_media.classList.add('active');
  });
  stl_media.addEventListener('mouseout', function(){
    stl_media.querySelector('.stl-product-count').style.width = '';
    stl_media.classList.remove('active');
  });
});